import Common from '../common'
var Js = Common('scoreOrder')
export default {
	name: 'scoreOrder',
	mixins: [Js],
	components: {},
	data() {
		return {
			fields: [{
					key: 'id',
					label: 'ID',
					application: [],
					componentName: 'sls-input',
					listType: '',
					width: 50
				},
				{
					key: 'order_no',
					label: '订单NO',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
					width: 150,
					header_search: {
						componentName: 'sls-input',
						style: 'width:160px;margin-right:2px;',
						placeholder: '请输入订单NO',
						clearable: true,
						defaultValue: '',
						optionsName: '',
						changeFunc: function(val, self) {
							if (val) {
								self.searchItem.order_no = val;
							} else {
								delete self.searchItem.order_no;
							};

						},
					},
				},
				{
					key: 'price',
					label: '订单金额',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: "pay_status",
					label: '支付状态',
					application: ['编辑'],
					type: 'select',
					listType: 'normal',
					formatter: function(val, tests) {
						if (val.pay_status == -1) {
							return '退款'
						} else if (val.pay_status === 0) {
							return '否'
						} else if (val.pay_status === 1) {
							return '是'
						}
					},
					componentName: 'sls-select',
					optionsName: 'payOptions',
					filter_multiple: false,
					listType: 'normal',
					defaultProps: {
						label: 'text',
						value: 'value',
					},
					placeholder: '请选择是否支付',
					width: 80,
					header_search: {
						componentName: 'sls-select',
						optionsName: 'payOptions',
						style: 'width:160px;margin-right:2px;',
						placeholder: '请选择是否支付',
						changeFunc: function(val, self) {
							if (val || val === 0) {
								self.searchItem.pay_status = val;
							} else {
								delete self.searchItem.pay_status;
							};

						},
					}
				},
				{
					key: "transport_status",
					label: '运输状态',
					application: ['编辑'],
					type: 'select',
					listType: 'normal',
					formatter: function(val, tests) {
						return ['未发货', '配送中', '已收货'][val.transport_status];
					},
					componentName: 'sls-select',
					optionsName: 'transportOptions',
					filter_multiple: false,
					defaultProps: {
						label: 'text',
						value: 'value',
					},
				},
				{
					key: "order_step",
					label: '订单状态',
					application: [],
					type: 'select',
					listType: 'normal',
					formatter: function(val, tests) {
						if (val.order_step == -1) {
							return '拒绝撤单'
						} else if (val.order_step === 0) {
							return '正常下单'
						} else if (val.order_step === 1) {
							return '申请撤单'
						} else if (val.order_step === 2) {
							return '已撤单'
						} else if (val.order_step === 3) {
							return '完结'
						}
					},
					componentName: 'sls-select',
					optionsName: 'stepOptions',
					filter_multiple: false,
					defaultProps: {
						label: 'text',
						value: 'value',
					},
				},
				/* {
					key: 'title',
					label: '下单商家',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
				}, */
				{
					key: 'user_no',
					label: '用户NO',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'name',
					label: '用户昵称',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
					formatter: function(val, tests) {
						return val.User.nickname ? val.User.nickname : '';
					},
				},
				/* {
					key: 'label_str',
					label: '商品分类',
					application: ['编辑', '添加'],
					componentName: 'sls-cascader',
					optionsName: 'labelOptions',
					listType: '',
					limit: 10,
					defaultProps: {
						children: 'children',
						label: 'title',
						value: 'id',
					},
					placeholder: '请选择分类',
					header_search: {
						componentName: 'sls-cascader',
						optionsName: 'labelOptions',
						style: 'width:160px;margin-right:2px;',
						placeholder: '请选择分类',
						defaultValue: [],
						changeFunc: function(val, self) {
							var arr = self.$$getChildNames(self.optionData.labelOptions, 'id', 'children', val,
								[]);
							if (val) {
								if (arr.length > 0) {
									var sres = [];
									for (var i = 0; i < arr.length; i++) {
										sres.push("%" + arr[i] + "%")
									};

									self.searchItem.label_str = ['like', sres, 'OR'];
								} else {
									self.searchItem.label_str = ['like', '%' + val + '%'];
								}
							} else {
								delete self.searchItem.label_str;
							};

						},
					}
				}, */
				{
					key: 'product_str',
					label: 'product_str',
					application: ['添加', '编辑'],
					componentName: 'sls-input',
					listType: '',

					header_search: {
						componentName: 'sls-input',
						placeholder: '请输入商品名称',
						suggest: true,
						defaultValue: '',
						querySearch: function(val, self) {
							console.log('querySearch')
							if (val) {
								var postData = {
									searchItem: {
										title: ['like', '%' + val + '%'],
										status: 1
									}
								};
								var res = self.initProductData(postData);
								return res;
							} else {
								delete self.searchItem.product_str;
							}


						},
						changeFunc: function(val, self) {
							if (val) {
								val = String(val);
								if (val.indexOf(",") > -1) {
									var arr = val.split(',');
									var sres = [];
									for (var i = 0; i < arr.length; i++) {
										sres.push("%" + arr[i] + "%")
									};
									self.searchItem.product_str = ['like', sres, 'OR'];
								} else {
									self.searchItem.product_str = ['like', ['%' + val + '%'], 'OR'];
								};
							} else {
								delete self.searchItem.product_str;
							};

						},
					}
				},
				{
					key: "status",
					label: '状态',
					application: [],
					componentName: 'sls-select',
					optionsName: 'statusOptions',
					defaultProps: {
						label: 'text',
						value: 'value',
					},
					formatter: function(val) {
						if (val.status == 1) {
							return '启用';
						} else {
							return '关闭';
						};
					}
				},
				{
					key: 'create_time',
					label: '创建时间',
					listType: 'normal',
					placeholder: '请选择创建时间',
					header_search: {
						componentName: 'sls-date-time-range',
						style: 'width:160px;margin-right:2px;',
						start_placeholder: '创建开始时间',
						end_placeholder: '创建结束时间',
						changeFunc: function(value, self) {
							if (!value) {
								delete self.searchItem.create_time;
							} else {
								self.searchItem.create_time = ['between', value = value.map(function(e) {
									return e / 1000;
								})]
							};
						},
					},
					width: 200,
				},
				{
					label: '操作',
					listType: 'deal',
					width: 200
				},
			],

			// 按钮配置
			btn_info: [


				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'list',
					text: function(data) {
						return '编辑'
					},
					func: {
						apiName: function(self) {
							return "api_orderUpdate"
						},
						formData: function(self) {
							return self.formData;
						},
						postData: function(self) {
							var postData = {
								searchItem: {
									id: self.formData.id,
									user_type: 0,
								},
								data: self.submitData
							};
							return postData;
						}
					},
				},
				{
					type: 'danger',
					icon: 'delete',
					size: 'mini',
					funcType: 'submit',
					position: 'header',
					text: function(data) {
						return '删除选中'
					},
					func: {
						apiName: function(self) {
							return "api_orderUpdate"
						},
						postData: function(self) {
							var deleteArray = [];
							for (var i = 0; i < self.selectionArray.length; i++) {
								deleteArray.push(self.selectionArray[i].id);
							};
							var postData = {
								searchItem: {
									id: ['in', deleteArray],
									user_type: 0,
								},
								data: {
									status: -1
								}
							};
							return postData;
						}
					},
				},
				{
					type: 'info',
					icon: 'edit',
					size: 'normal',
					position: 'header',
					func: {
						func: function(self) {
							self.excelOutput(self);
						},
					},
					text: function(data) {
						return '导出'
					},
					funcType: 'func',
				},
			],

			searchItem: {
				type: 2
			},
			startSearchItem: {
				type: 2
			},
			optionData: {
				statusOptions: [{
					text: '启用',
					value: 1
				}, {
					text: '禁用',
					value: -1
				}],
				payOptions: [{
					text: '未支付',
					value: 0
				}, {
					text: '已支付',
					value: 1
				}],
				transportOptions: [{
					text: '未发货',
					value: 0
				}, {
					text: '配送中',
					value: 1
				}, {
					text: '已收货',
					value: 2
				}],
				stepOptions: [{
					text: '正常下单',
					value: 0
				}, {
					text: '申请撤单',
					value: 1
				}, {
					text: '已撤单',
					value: 2
				}, {
					text: '完结',
					value: 3
				}],
				behaviorOptions: [{
					text: '采购',
					value: 1
				}, {
					text: '仓储',
					value: 2
				}],
				labelOptions: [],
			},
			otherData: {},
			UserInfo: {
				tableName: 'UserInfo',
				searchItem: {},
				key: 'user_no',
				middleKey: 'user_no',
				condition: 'in',
			}

		}

	},

	mounted() {
		const self = this;
		self.table_arguments.tree_props = {
			children: 'child',
			child: 'child',
			hasChildren: 'child'
		}
		self.table_arguments.expand = true;
		self.searchData = self.$$cloneForm(self.searchItem);
		this.init()
	},
	computed: {
		token: function() {
			return this.$store.getters.getToken
		}
	},
	methods: {

		/**
		 * 初始化
		 */
		init() {
			this.initMainData();
			this.initLabel();
		},


		/**
		 * 列表主函数
		 */
		async initMainData(isNew) {

			const self = this;
			self.table_arguments.loading = true;
			const postData = {};
			if (isNew) {
				self.paginate.currentPage = 1;
			};
			postData.paginate = self.$$cloneForm(self.paginate);
			postData.token = self.$store.getters.getToken;
			if (self.searchItem) {
				postData.searchItem = self.$$cloneForm(self.searchItem)
			};
			if (JSON.stringify(self.getBefore) != "{}") {
				postData.getBefore = self.$$cloneForm(self.getBefore);
			};
			postData.getAfter = {
				User: {
					tableName: 'User',
					middleKey: 'user_no',
					key: 'user_no',
					condition: '=',
					searchItem: {
						status: 1
					},
					info: ['nickname'],
				},
			};

			var res = await self.$$api_orderGet({
				data: postData
			});
			self.mainData = res.info.data;
			self.paginate.count = res.info.total;
			self.table_arguments.loading = false;

		},

		/**
		 * 列表主函数
		 */
		async initLabel() {

			const self = this;

			const postData = {};
			postData.token = self.$store.getters.getToken;
			postData.searchItem = {
				id: ["not in", [12, 14, 15]],
				thirdapp_id: 2,
				type: 2
			};
			var res = await self.$$api_labelGet({
				data: postData
			});
			self.optionData.labelOptions = res.info.data;


		},

		async initProductData(postData) {

			const self = this;
			postData.token = self.$store.getters.getToken;
			var res = await self.$$api_productGet({
				data: postData
			});

			if (res.info.data.length > 0) {
				for (var i = 0; i < res.info.data.length; i++) {
					res.info.data[i]['value'] = res.info.data[i]['title'];
					res.info.data[i]['product_str'] = res.info.data[i]['id'];
				};
				return res.info.data;
			} else {
				return [{
					"value": "无",
					"product_str": ""
				}];
			};

		},


	},


}



// WEBPACK FOOTER //
// ./src/views/order/scoreOrder.js